import { OpportunityStage } from "@/graphql"

export const stageOrder: OpportunityStage[] = [
	OpportunityStage.Targets,
	OpportunityStage.TargetsWithContact,
	OpportunityStage.InterestedToSell,
	OpportunityStage.AnalysisCompleted,
	OpportunityStage.AnalysisPresentedAndPsaSubmittedToBuyer,
	OpportunityStage.PsaPresentedToSeller,
	OpportunityStage.DueDiligenceInProgress,
	OpportunityStage.ConditionsLifted,
	OpportunityStage.ReadyForClosing,
	OpportunityStage.ClosedWon,
	OpportunityStage.ClosedLost,
]

const stageBaseNames: Record<OpportunityStage, string> = {
	[OpportunityStage.Targets]: "Targets",
	[OpportunityStage.TargetsWithContact]: "Targets with contact",
	[OpportunityStage.InterestedToSell]: "Interested to sell",
	[OpportunityStage.AnalysisCompleted]: "Analysis completed",
	[OpportunityStage.AnalysisPresentedAndPsaSubmittedToBuyer]: "Analysis presented and PSA submitted to buyer",
	[OpportunityStage.PsaPresentedToSeller]: "PSA presented to seller",
	[OpportunityStage.DueDiligenceInProgress]: "Due diligence in progress",
	[OpportunityStage.ConditionsLifted]: "Conditions lifted",
	[OpportunityStage.ReadyForClosing]: "Ready for closing",
	[OpportunityStage.ClosedWon]: "Closed won",
	[OpportunityStage.ClosedLost]: "Closed lost",
}

export const stageLabelMap = Object.fromEntries(stageOrder.map((s, i) => [s, `${i}. ${stageBaseNames[s]}`])) as Record<
	OpportunityStage,
	string
>
